import { useBridgeEvents } from './useBridgeEvents.ts';

const selectBridgeEventData = <T>(_id: string, _eventName: string, data?: T): T | undefined => data;

export const useBridgeEventsData = <T>(eventNames: string[], useSimpleMessage: boolean = false) =>
  useBridgeEvents<T, T | undefined>(eventNames, selectBridgeEventData, useSimpleMessage);
